import type { Client, RequestContext } from "../client";
import type { PerformanceConfigurationResource } from "../resources/performanceConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";
export class PerformanceConfigurationRepository extends ConfigurationRepository<PerformanceConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("PerformanceConfiguration", client, requestContext);
    }
}
